import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { Subject } from "rxjs";
import { finalize, takeUntil } from "rxjs/operators";
import { SpinService } from "../shared/services/spin-service.service";
import { BACKGROUND_REQUEST } from "../shared/utils/background-request";

@Injectable()
export class SpinInterceptor implements HttpInterceptor {
  private totalRequests = 0;
  private cancelPendingRequests = new Subject<void>();

  constructor(
    private spinService: SpinService,
    private router: Router,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart && !spinService.nbDisabled) {
        // If navigation starts, emit a value to cancel pending requests
        try {
          this.cancelPendingRequests.next();
        } catch (error) {
          console.log("catch cancel pending errors");
        }
      }
    });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    // Lecture de FOND : ni barre de progression, ni annulée par une navigation (`background-request.ts`).
    if (request.context.get(BACKGROUND_REQUEST)) return next.handle(request);
    this.totalRequests++;
    this.spinService.spin(true);

    return next.handle(request).pipe(
      takeUntil(this.cancelPendingRequests),
      finalize(() => {
        this.totalRequests--;
        if (this.totalRequests === 0) {
          this.spinService.spin(false);
        }
      }),
    );
  }
}
